module.exports = __webpack_public_path__ + "assets/terms/termos-ar.5cb65b1d.pdf";